import './Icon.css'
import BackwardArrowIcon from './icons/backwardArrowIcon'
import { useTranslator } from '../translator/hook'

interface BackButtonProps {
  onClick: () => void
}

export const BackButton = ({ onClick }: BackButtonProps) => {
  const { t } = useTranslator()

  return (
    <div className="menu-container icon-container">
      <button className="icon-button" onClick={onClick}>
        <BackwardArrowIcon className="icon" />
        <div className="icon-caption">{t('UNDO')}</div>
      </button>
    </div>
  )
}
